<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="cn" id="_idParaDest-6"><a id="_idTextAnchor005"></a><a href="#/text/9780062652874_Contents#r_idParaDest-6"><span class="right_1" epub:type="pagebreak" id="page_19" title="19">Ana</span></a></h2>
<p class="noindent">The skysailer with that stupid Ironblood climbed into the air, leaving a cold feeling in Ana’s gut. There went Di’s last chance, disappearing into the Nevaeh sky right before her eyes.</p>
<p class="indent">Behind her, the shrine’s side door buckled out with the force of the Messiers on the other side.</p>
<p class="indent">Di pressed his back against the door to keep it closed. He must have stopped glitching after she lobbed the flashbang.</p>
<p class="indent">“That door won’t hold,” Mokuba said nervously, taking her by the arm. “Kid, you gotta get out of here before they break through. If they catch you <i>or </i>your Metal, then Siege’ll skin me alive. You were stupid to come after those coordinates. I told you <i>no </i>to begin with—”</p>
<p class="indent">“I have to!” She twisted out of Mokuba’s grip. “Di, we need to call Jax.”</p>
<p class="indent">“On his way,” Di replied.</p>
<p class="indent">She gave a relieved sigh. “Goddess, I’m glad you didn’t glitch long.”</p>
<p class="indent">“My”—<i>Thud! </i>The door shook again—“apologies.”</p>
<p class="indent"><span class="right_1" epub:type="pagebreak" id="page_20" title="20">“Kid, don’t go after it,” Mokuba begged. “It’s cursed. People have died for those coordinates. You don’t understand. This whole thing is—”</span></p>
<p class="indent">A lightsword sliced through the door beside Di’s head. He ducked out of the way, but not quick enough before it tore through half of his hood.</p>
<p class="indent">Sweat prickled on Mokuba’s upper lip. “Ana, you have to run.”</p>
<p class="indent">“But—”</p>
<p class="indent">“<i>Now</i>,” the info broker snapped. His black eyes were frightened and desperate. She had never seen Mokuba like this before. “Siege’ll kill me if anything happens to you.”</p>
<p class="indent">“What’ll you do?”</p>
<p class="indent">“Distract them.”</p>
<p class="indent">Alarmed, she shook her head. “They’ll catch you. They’ll—”</p>
<p class="indent">The Messiers kicked the door open, and it fell outward with a terrifying crash.</p>
<p class="indent">Hurtling over the railing, Di landed at the bottom of the stairs and curled his cold gloved hand around her wrist. He pulled her down the grimy alleyway before she had a chance to argue, leaving Mokuba to face the Messiers alone.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062652874_Chapter_3.vue?0413d725